import React, {useContext, useState} from "react";
import * as Sentry from '@sentry/browser';
import {FormattedMessage} from "react-intl";
import Api from "../../Api";
import Icon from "../Utils/Icon";
import classes from "./styles.module.css";
import MessageContext from "../../MessageContext";

function RegistryDADUpload({token, onRegistryUpload, merchantUuid}) {
    const {onMessage} = useContext(MessageContext);
    const [drag, setDrag] = useState(false);
    const [loading, setLoading] = useState(false);

    function uploadRegistry(file) {
        if (!file) return;

        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);

        new Api({token})
            .registryUpload(formData, merchantUuid)
            .then((r) => {
                const hasFormatError = !!(r && r.errors && r.errors.formatError);

                if (r && !hasFormatError && !r.code) {
                    onRegistryUpload(file, r);
                    return;
                }

                const code = r && r.code ? r.code : "formatError";
                onMessage({
                    type: "error",
                    message: (
                        <FormattedMessage
                            id="RegistryDADUpload.error.format"
                            defaultMessage="(код: {code}) Ошибка! Реестр не соответствует формату. Устраните ошибки и повторите попытку."
                            values={{code}}
                        />
                    ),
                });
            })
            .catch((err) => {
                Sentry.captureException(err);
                onMessage({
                    type: "error",
                    message: (
                        <FormattedMessage
                            id="RegistryDADUpload.error.network"
                            defaultMessage="Ошибка загрузки. Попробуйте снова."
                        />
                    ),
                });
            })
            .finally(() => setLoading(false));
    }

    function onDragStartHandler(e) {
        e.preventDefault();
        setDrag(true);
    }

    function onDragLeaveHandler(e) {
        e.preventDefault();
        setDrag(false);
    }

    function onDropHandler(e) {
        e.preventDefault();
        setDrag(false);
        const files = e.dataTransfer && e.dataTransfer.files;
        if (files && files.length > 0) {
            uploadRegistry(files[0]);
        }
    }

    function onAddingFileHandler() {
        const input = document.createElement("input");
        input.type = "file";
        input.onchange = (e) => {
            const target = e.target;
            if (target && target.files && target.files.length > 0) {
                uploadRegistry(target.files[0]);
            }
        };
        input.click();
    }

    return (
        <div className={drag ? `${classes.Wrap} ${classes.IsDrag}` : classes.Wrap}>
            <div
                onClick={onAddingFileHandler}
                onDrop={onDropHandler}
                onDragStart={onDragStartHandler}
                onDragLeave={onDragLeaveHandler}
                onDragOver={onDragStartHandler}
                style={{cursor: 'pointer'}}
            >
        <span>
          <Icon className={classes.Icon} icon="cloud-upload" size="40px"/>
            {loading ? (
                <FormattedMessage id="RegistryDADUpload.loading" defaultMessage="Обработка..."/>
            ) : (
                <FormattedMessage
                    id="RegistryDADUpload.hint"
                    defaultMessage="Перетащите реестр в эту область или нажмите для выбора"
                />
            )}
        </span>
            </div>
        </div>
    );
}

export default RegistryDADUpload;



// WEBPACK FOOTER //
// ./src/Components/RegistryDADUpload/index.js